import { RefObject, useCallback } from 'react';

import { ApiJobId } from 'api/types/ApiTypedId';

type Args = {
  scrollingParentRef: RefObject<HTMLElement | null>;
};

export function useViewJobPageSidebarResultsScroll({
  scrollingParentRef,
}: Args) {
  const scrollToJobId = useCallback(
    (jobId: ApiJobId) => {
      const scrollingParent = scrollingParentRef.current;

      const hitElement = scrollingParent?.querySelector(
        `[data-hit-id="${jobId}"]`,
      ) as HTMLElement | null;

      hitElement?.scrollIntoView({ block: 'start' });
    },
    [scrollingParentRef],
  );

  return { scrollToJobId };
}
